
import React, { useCallback } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { formatTooltipBudgetChangeType, formatTooltipEventType } from '../utils/tooltip-card';

const { BudgetEventType, BudgetChangeType } = Constants;

export function TooltipSectionContentItem({
  title, value,
}) {
  return (
    <div className="budget-center-tooltip-section-content-item">
      <span className="budget-center-tooltip-item-key">{title}</span>
      <span className="budget-center-tooltip-item-value">{value}</span>
    </div>
  );
}

export function TooltipSectionEventItem({
  i18n,
  budgetEventType,
  budgetChangeType,
  eventHistory,
  currencyCode,
}) {
  const tooltipEvent = budgetEventType ? formatTooltipEventType({
    i18n, eventType: budgetEventType,
  }) :
    formatTooltipBudgetChangeType({
      i18n, eventType: budgetChangeType, eventHistory, currencyCode,
    });
  const hintNode = useCallback(({ type, clicks }) => (
    <span className="budget-center-tooltip-event-hint">
      <span className={`clicks-after-change ${type}`}>{i18n.getString(_TL_('{{clicks}} daily clicks'), { clicks })}</span>
      <span>{i18n.getString(_TL_('after change'), { comment: 'The full string is: {{clickNumber}} daily clicks after change. {{{clickNumber}} daily clicks} is another TL string.' })}</span>
    </span>
  ), [i18n]);

  return tooltipEvent && (
    <div className="budget-center-tooltip-section-event-item">
      <div className="budget-center-tooltip-event-message">{tooltipEvent.message}</div>
      {tooltipEvent.hint && hintNode({ type: tooltipEvent.hint.type, clicks: tooltipEvent.hint.clicks })}
    </div>);
}

export function TooltipCardSection({
  name,
  header,
  children,
}) {
  return (
    <div className={classnames('budget-center-tooltip-card-section', `budget-center-tooltip-card-${name}-section`)}>
      {header && (
        <div className={classnames('budget-center-tooltip-card-section-header')}>
          {header}
        </div>)}
      <div className="budget-center-tooltip-card-section-content">
        {children}
      </div>
    </div>
  );
}

TooltipSectionContentItem.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

TooltipSectionEventItem.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  currencyCode: PropTypes.string.isRequired,
  budgetEventType: PropTypes.oneOf(_.values(BudgetEventType)),
  budgetChangeType: PropTypes.oneOf(_.values(BudgetChangeType)),
  eventHistory: PropTypes.shape({
    FieldName: PropTypes.string,
    NewValue: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    OldValue: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    DailyClickChange: PropTypes.number,
  }),
};
TooltipSectionEventItem.defaultProps = {
  budgetEventType: null,
  budgetChangeType: null,
  eventHistory: null,
};

TooltipCardSection.propTypes = {
  name: PropTypes.string.isRequired,
  header: PropTypes.node,
  children: PropTypes.node,
};

TooltipCardSection.defaultProps = {
  header: null,
  children: null,
};
